import React from 'react';
import './DoodleyDifferenceSection.css';

import expertIcon from '../assets/expertVets.png'
import samedayVisit from '../assets/sameDayVisit.png'
import completeTreatment from '../assets/completeTreatments.png'

// In a real application, you would import your icons like this:
// import vetIcon from '../assets/vet-icon.svg';
// import clockIcon from '../assets/clock-icon.svg';
// import medsIcon from '../assets/meds-icon.svg';

const DoodleyDifferenceSection = () => {
  return (
    <section className="doodley-difference-section">
      <div className='test'>
      <h2 className="section-title">
        <span className="title-orange">Why Choose</span> <span className="highlight">Dr<span className='dot'>.</span> Doodley</span>
      </h2>

      <div className="main-container">
        <div className="services-header">
          HOSPITAL BACKED SERVICES
        </div>

        <div className="service-list">
          <div className="service-item">
            <div className="icon-container">
              {/* 
                An icon image or SVG would go here. For example:
                <img src={vetIcon} alt="Expert Vets Icon" />
              */}
            </div>
            <div className="text-container">
              <img src={expertIcon} alt='icon' className='service-icon-top'></img>
              <h3>20+ Expert Vets</h3>
              <p>Surgery, Gynacology, Dermatology & Other</p>
            </div>
          </div>

          <div className="service-item">
            <div className="icon-container">
              {/* <img src={clockIcon} alt="Same-Day Visit Icon" /> */}
            </div>
            <div className="text-container">
              <img src={samedayVisit} alt='icon' className='service-icon'></img>
              <h3>Same-Day Visit</h3>
              <p>Quick Vet Visits At Your Home</p>
            </div>
          </div>

          <div className="service-item">
            <div className="icon-container">
              {/* <img src={medsIcon} alt="Complete Treatment Icon" /> */}
            </div>
            <div className="text-container">
              <img src={completeTreatment} alt='icon' className='service-icon'></img>
              <h3>Complete Treatment</h3>
              <p>Our Vets Come With All Necessary Medication</p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default DoodleyDifferenceSection;